module.exports = __webpack_public_path__ + "img/17a001-18.4f3dc5b6.jpg";